export const AssessmentActivityType = {
  Interview: 'interview',
  Meeting: 'meeting',
  Reminder: 'reminder',
  Review: 'review',
  Task: 'task',
} as const;

export type AssessmentActivityType =
  (typeof AssessmentActivityType)[keyof typeof AssessmentActivityType];
